/**
 * 禁用模拟鼠标事件，安全防控
 */
function f (hrefReg) {
  if(hrefReg.test(location.href)) {
    window['E'+'v'+'e'+'n'+'t'+'T'+'a'+'r'+'g'+'e'+'t'].prototype['d'+'i'+'s'+'p'+'a'+'t'+'c'+'h'+'E'+'v'+'e'+'n'+'t'] = function () {
    }
  }
}
const reg = /static\/verify\.html/
f(reg)